
	export default {
		data() {
			return {
				limit: 1000 * 5,
				current: 0,
				longest: 0
			}
		},
		methods: {
			changeTestimonial(){
				this.current++;
				if(this.current >= this.$parent.config.testimonials.length) this.current = 0;
			}
		},
		created(){
			let maxCount = 0
			for(let i = 0; i < this.$parent.config.testimonials.length; i++){
				if(this.$parent.config.testimonials[i].length > maxCount){
					maxCount = this.$parent.config.testimonials[i].length
					this.longest = i
				}
			}
			setInterval(this.changeTestimonial, this.limit)
		}
	}
